<template>
  <div class="card has-padding-20 has-padding-left-0">
    <div class="has-margin-bottom-40 has-margin-top-10 has-border-bottom">
      <h2
        class="is-size-4 has-text-weight-bold is-uppercase has-letter-spacing-3 is-black"
      >Confirmation</h2>
    </div>

    <div class="card-content">
      <validation-observer
        ref="confirmationObserver"
        tag="div"
        v-slot="{invalid, valid, untouched, errors}"
      >
        <h2 class="is-size-5 has-text-weight-semibold has-margin-bottom-15">SHIPPER'S DECLARATION</h2>
        <p>
          I hereby declare that the contents of this consignment are fully and accurately described above by the Proper
          Shipping Name and UN Number, and are classified, packed, marked and labeled/placarded and are in all respects in proper condition
          for transport according to the applicable international and national government regulations.
        </p>

        <div class="columns is-multiline has-margin-top-30">
          <div class="column is-6">
            <input-with-validation
              :rules="'required'"
              :model="shipperDeclaration.company_name"
              :vuexKey="'shipper_declaration_company_name'"
              :label="'Name of Company (Shipper)'"
              :errorLabel="`Company Name`"
              :name="'companyName'"
              :placeholder="'Company Name'"
              @input="updateVuex"
            ></input-with-validation>
          </div>
          <div class="column is-6">
            <input-with-validation
              :rules="'required'"
              :model="shipperDeclaration.name_of_declarant"
              :vuexKey="'shipper_declaration_name_of_declarant'"
              :label="'Name of Declarant'"
              :errorLabel="`Declarant Name`"
              :name="'declarantName'"
              :placeholder="'Declarant Name'"
              @input="updateVuex"
            ></input-with-validation>
          </div>
          <div class="column is-6">
            <input-with-validation
              :rules="'required'"
              :model="shipperDeclaration.status_of_declarant"
              :vuexKey="'shipper_declaration_status_of_declarant'"
              :label="'Status of Declarant'"
              :errorLabel="`Declarant Status`"
              :name="'declarantStatus'"
              :placeholder="'Declarant Status'"
              @input="updateVuex"
            ></input-with-validation>
          </div>

          <div class="column is-6">
            <date-input-with-validation
              :rules="'required|date_format:dd/MM/yyyy'"
              :model="date"
              :vuexKey="'shipper_declaration_date'"
              :label="'Date'"
              :errorLabel="`Date`"
              :name="'date'"
              :placeholder="'Date'"
              :disabled="true"
            ></date-input-with-validation>
          </div>
        </div>
        <div class="has-margin-top-50">
          <!-- Form Buttons -->
          <div class="steps-actions has-margin-top-30">
            <div class="steps-action">
              <a href="#" class="button is-danger" @click="moveToPrevious">Previous</a>
            </div>
            <div class="steps-action">
              <button class="button is-primary" @click="submit">Submit Shipping Request</button>
            </div>
          </div>
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import InputWithValidation from "./form-inputs/InputWithValidation";
import DateInputWithValidation from "./form-inputs/DateInputWithValidation";
import * as moment from "moment";
import isValidDate from "@/modules/commonModule/helpers/isValidDate";

import { SHIPPER_MUTATION_TYPES } from "@/store/mutation-types";
import { createNamespacedHelpers } from "vuex";
const { mapMutations } = createNamespacedHelpers("shippers");

export default {
  name: "Confirmation",

  components: {
    ValidationObserver,
    InputWithValidation,
    DateInputWithValidation
  },

  props: {
    moveToPrevious: { type: Function, required: true },
    submitShippingRequest: { type: Function, required: true },
    shipperDeclaration: { type: Object, required: true }
  },

  computed: {
    /**
     * Format the date to a format that can be used to "prefill" the date picker
     */
    date() {
      let declarationDate = moment(new Date(), "YYYY-MM-DD");
      const date = new Date(
        declarationDate.year(),
        declarationDate.month(),
        declarationDate.date()
      );

      if (isValidDate(date)) {
        return date;
      } else {
        return null;
      }
    }
  },

  mounted() {
    let declarationDate = moment(new Date(), "YYYY-MM-DD");
    const date = new Date(
      declarationDate.year(),
      declarationDate.month(),
      declarationDate.date()
    );
    if (isValidDate(date)) {
      let utcDate = moment(date).format("YYYY-MM-DD");
      this.updateVuex({
        key: "shipper_declaration_date",
        value: utcDate
      });
      return date;
    } else {
      return null;
    }
  },

  methods: {
    ...mapMutations({
      updateShipperDeclaration:
        SHIPPER_MUTATION_TYPES.UPDATE_SHIPPER_DECLARATION
    }),

    updateVuex: function({ key, value }) {
      this.updateShipperDeclaration({ key, value });
    },

    submit: async function() {
      const isValid = await this.$refs.confirmationObserver.validate();
      if (!isValid) {
        this.$toast.open({
          duration: 4000,
          position: "is-top-right",
          message: "Confirmation details is incomplete. Please review.",
          type: "is-danger"
        });

        return;
      }
      this.submitShippingRequest();
    }
  }
};
</script>
